import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

const robotsTxtDeny = `
User-agent: *
Disallow: /
`.trim()

function runtimeEnv(key: string) {
  return (
    import.meta.env[key] ||
    (typeof process !== "undefined" ? process.env[key as keyof typeof process.env] : undefined)
  )
}

function prodHostFromRequest(request?: Request) {
  if (!request) return false

  const host = new URL(request.url).hostname
  return host === "playbrain.com"
}

function robotsTxt(request?: Request) {
  const site =
    runtimeEnv("SITE") ||
    runtimeEnv("DOMAIN") ||
    (request ? new URL(request.url).origin : "https://playbrain.com")
  return `
User-agent: *
Allow: /
Disallow: /404
Disallow: /500

Sitemap: ${new URL("sitemap.xml", site).href}
`.trim()
}

function shouldServeIndexableRobots(request?: Request) {
  const stage = runtimeEnv("PUBLIC_STAGE") || runtimeEnv("VITE_PUBLIC_STAGE")
  return (
    stage === "prod" ||
    prodHostFromRequest(request) ||
    runtimeEnv("PUBLIC_LIGHTHOUSE_INDEXABLE") === "true" ||
    runtimeEnv("VITE_PUBLIC_LIGHTHOUSE_INDEXABLE") === "true"
  )
}

export const Route = createFileRoute("/robots.txt")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) =>
          new Response(shouldServeIndexableRobots(request) ? robotsTxt(request) : robotsTxtDeny, {
            headers: { "Content-Type": "text/plain; charset=utf-8" },
          }),
      },
    },
  })
)
